var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.156 6.75C44.91 6.75 49.492 11.2019 49.492 18.7602V18.844H39.964C35.53 18.8518 31.938 22.3541 31.93 26.6773C31.924 31.0102 35.52 34.5281 39.964 34.5339H49.5V35.2223C49.5 42.7806 44.918 47.25 37.164 47.25H16.838C9.082 47.25 4.5 42.7806 4.5 35.2223V18.7602C4.5 11.2019 9.082 6.75 16.838 6.75H37.156ZM27.862 15.4685H15.164C14.22 15.4724 13.454 16.2193 13.45 17.1417C13.446 18.0679 14.214 18.8226 15.164 18.8265H27.878C28.828 18.8226 29.596 18.0679 29.592 17.1397C29.588 16.2135 28.812 15.4646 27.862 15.4685Z",
    fill: "url(#paint0_linear_3359_23018)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M29.3763 29.2313C30.0821 34.5817 32.8966 38.346 36.11 38.2481H47.0785C48.4155 38.2481 49.5 36.4027 49.5 34.1215V19.8815C49.4971 17.6053 48.4155 15.7549 47.0785 15.75H35.8518C32.1966 15.7696 29.2443 20.8263 29.25 27.0578C29.25 27.7872 29.2931 28.5166 29.3763 29.2313Z",
    fill: "url(#paint1_linear_3359_23018)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.25 29.25C39.4926 29.25 40.5 28.2426 40.5 27C40.5 25.7574 39.4926 24.75 38.25 24.75C37.0074 24.75 36 25.7574 36 27C36 28.2426 37.0074 29.25 38.25 29.25Z",
    fill: "url(#paint2_linear_3359_23018)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3359_23018",
    x1: 27,
    y1: 6.75,
    x2: 27,
    y2: 47.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2666FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0841C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3359_23018",
    x1: 39.375,
    y1: 15.75,
    x2: 39.375,
    y2: 38.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2666FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0841C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3359_23018",
    x1: 38.25,
    y1: 24.75,
    x2: 38.25,
    y2: 29.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2666FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0841C5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.a3752b676f15000d67be9036e93d1d64.svg";
export { ForwardRef as ReactComponent };